import React from "react";
import ScrollAnimation from "react-animate-on-scroll";
import ellipse from "../../../assets/Ellipse2.svg";
import safeDelivery from "../../../assets/safeDelivery.svg";
import bicycle from "../../../assets/bicycle.svg";
import locationInvert from "../../../assets/locationInvert.svg";
import reliable from "../../../assets/reliable.svg";
import Container from "./styles";

const SectionOne = () => {
  return (
    <ScrollAnimation animateIn="fadeIn">
      <Container>
        <div className="reasons">
          <div className="ellipse--container">
            <img src={ellipse} alt="Ellipse" />
            <h3>Why You Should Use Pickorders </h3>
          </div>
          <p>
            Send your parcels the easy way and request for collection
            the easiest way from the comfort of your home{" "}
          </p>
        </div>
        <div className="points--container">
          <div className="points--col__1">
            <div className="keyPoints--container">
              <img src={safeDelivery} alt="safe delivery" />
              <h3>Safe delivery</h3>
              <p>
                We treat your parcel with utmost care from the point of pickup
                to delivery. Our team of professional delivery agents will
                ensure your cherished packages get to its destination safely.
            
              </p>
            </div>
            <div className="keyPoints--container">
              <img src={reliable} alt="safe delivery" />
              <h3>Reliable services</h3>
              <p>
                astar.ng operates a zero-cancellation policy across the
                routes we operate. We ensure our pick-up and delivery time are
                well estimated to avoid and delays
              </p>
            </div>
          </div>
          <div className="points--col__2">
            <div className="keyPoints--container">
              <img src={bicycle} alt="safe delivery" />
              <h3>Same day delivery</h3>
              <p>
                Our sameday courier guarantees delivery of urgent items on the
                same day, with frequent delivery confirmation.
              </p>
            </div>
            <div className="keyPoints--container">
              <img src={locationInvert} alt="safe delivery" />
              <h3>Realtime tracking</h3>
              <p>
                We will be offering real-time tracking to help determine the
                actual state of your packages. In case it gets stuck in traffic
                or our delivery bikes or vehicle needs to take another route
                then our prospective client can also be informed of this change.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </ScrollAnimation>
  );
};

export default SectionOne;
